export default "__VITE_ASSET__4IYmMc1w__"